import Close from './assets/close-x.svg';

const BtnModalCloseX = ({ onClick, ...rest }) => {
    return (
        <button
            aria-label="Close"
            type="button"
            onClick={onClick}
            data-testid="modal-close-x"
            className="modal-close-x"
            height="30px"
            width="30px"
            {...rest}
            style={{ zIndex: 1 }}
        >
            <img alt="Close" src={Close} loading="lazy" />
        </button>
    );
};

export default BtnModalCloseX;
